module.exports = __webpack_public_path__ + "img/myInitialEle.5db5eaf0.svg";